<template>
    <div class="auth-wrapper auth-v1 px-2">
      <b-modal
        id="modal-scrollable"
        scrollable
        title="使用條款（包括有關私隱政策，免責聲明及版權的條款）"
        size="lg"
        ok-title="關閉"
        ok-only
      >
        <b-card-text
          v-for="(content,index) in scrollContent"
          :key="index"
        >
          {{ content }}
        </b-card-text>
      </b-modal>
      <div class="auth-inner py-2">
  
        <!-- Register v1 -->
        <b-card class="mb-0">
          <b-link class="brand-logo">
            <h2 class="brand-text text-primary ml-1">
              Rainbow Creative Arts
            </h2>
          </b-link>
  
          <b-card-title class="mb-1">
            學員登記表格
          </b-card-title>
          <b-card-text class="mb-2">
  
          </b-card-text>
  
          <!-- form -->
          <validation-observer ref="registerForm">
            <h4 class="brand-text text-primary ml-1" v-if="valid === false">Invalid Link</h4>
            <b-form v-if="insert === false && valid === true">
              <b-form-group
                label="中文姓名 Chinese Name*"
                label-for="zh_name"
              >
                <b-form-input
                  id="zh_name"
                  autocomplete="off"
                  disabled
                  v-model="student.zh_name"
                  trim
                />
  
              </b-form-group>
  
               <b-form-group
                 label="英文姓名 English Name *"
                 label-for="card"
               >
                 <b-form-input
                   id="card"
                   v-model="student.en_name"
                   autocomplete="off"
                   disabled
                   trim
                 />
  
               </b-form-group>
               <b-form-group
                 label="在學級別 *"
                 label-for="scholl_grade"
               >
                 <v-select
                   id="scholl_grade"
                   :clearable="false"
                   :options="schoolGradeOptions"
                   :reduce="g => g.value"
                   disabled
                   v-model="student.school_grade"
                   trim
                 />
  
  
               </b-form-group>
             <b-form-group
               label="出生日期 Date of Birth (YYYY-MM-DD)"
               label-for="Expiry Date"
             >
               <b-form-input
                 id="expire"
                 v-mask="'####-##-##'"
                 disabled
                 v-model="student.birth"
                 autocomplete="off"
                 trim
               />
  
             </b-form-group>
  
             <b-form-group
               label="地址 Address"
               label-for="address"
             >
  
               <b-form-textarea
               id="address"
               v-model="student.address"
               autocomplete="off"
               disabled
               trim/>
  
             </b-form-group>
             <b-form-group
               label="主要聯絡電話 Contact Mobile"
               label-for="mobile"
             >
               <b-form-input
                 id="mobile"
                 v-model="student.mobile"
                 autocomplete="off"
                 disabled
                 trim
               />
  
             </b-form-group>
  
             <b-form-group
               label="性別 Gender"
               label-for="gender"
             >
               <v-select
                 id="gender"
                 :clearable="false"
                 :options="genderOptions"
                 :reduce="g => g.value"
                 v-model="student.gender"
                 disabled
                 trim
               />
  
             </b-form-group>
             <hr class="my-3"/>
            
              <b-form-group>
                <b-form-checkbox
                  id="register-privacy-policy"
                  v-model="status"
                  name="checkbox-1"
                >
                  我已閱讀及同意<b-link v-b-modal.modal-scrollable>使用條款（包括有關私隱政策，免責聲明及版權的條款）</b-link>
  
                </b-form-checkbox>
              </b-form-group>
              <!-- <VueSignaturePad ref="signaturePad" height="150px" :options="{ dotSize: 2, throttle: 16,backgroundColor: 'rgba(200,200,200,1)',onBegin, onEnd }"/>
              <b-button v-ripple.400="'rgba(255, 159, 67, 0.15)'" class="mt-1" block @click="clear()" variant="outline-warning">
                  清除簽名
              </b-button> -->
              
              <hr class="my-2"/>
              <b-button
                variant="primary"
                block
  
                type="button"
                @click="submit"
              >
                送出 Submit
              </b-button>
            </b-form>
          </validation-observer>
  
  
  
  
        </b-card>
      <!-- /Register v1 -->
      </div>
    </div>
  
  </template>
  
  <script>
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import {
    BCard, BLink, BCardTitle, BCardText, BForm,
    BButton, BFormInput, BFormGroup, BInputGroup, BInputGroupAppend, BFormCheckbox,BFormTextarea
  } from 'bootstrap-vue'
  import router from '@/router'
  import VuexyLogo from '@core/layouts/components/Logo.vue'
  import { required, email } from '@validations'
  import { togglePasswordVisibility } from '@core/mixins/ui/forms'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import vSelect from 'vue-select'
  import Nl2br from 'vue-nl2br'
  import VueSignaturePad from 'vue-signature-pad'
  export default {
    components: {
      VuexyLogo,
      // BSV
      BCard,
      Nl2br,
      BLink,
      BCardTitle,
      router,
      BCardText,
      BFormTextarea,
      BForm,
      BButton,
      BFormInput,
      BFormGroup,
      vSelect,
      BInputGroup,
      BInputGroupAppend,
      BFormCheckbox,
      // validations
      ValidationProvider,
      ValidationObserver,
    },
    mixins: [togglePasswordVisibility],
    data() {
      return {
        regEmail: '',
        student:null,
        username: '',
        valid : true,
        password: '',
        status: false,
        insert: false,
        genderOptions:[
          { label:'男 Male',value:'M'},
          { label:'女 Female',value:'F'}
        ],
        schoolGradeOptions: [
          { label: 'M', value: 'M' },
          { label: 'K1', value: 'K1' },
          { label: 'K2', value: 'K2' },
          { label: 'K3', value: 'K3' },
          { label: 'P1', value: 'P1' },
          { label: 'P2', value: 'P2' },
          { label: 'P3', value: 'P3' },
          { label: 'P4', value: 'P4' },
          { label: 'P5', value: 'P5' },
          { label: 'P6', value: 'P6' },
        ],
        scrollContent: [
          `條款及細則`,
          `1. 貴家長須依時接送貴子弟。`,
          `2. 如非本校邀請，家長或其他賓客均不得擅自進入課室。`,
          `3. 課堂進行期間，課室內不可飲食。`,
          `4. 同學須於每堂上課前將學生手冊交到詢問處報到，如有遺失學生手冊須額外繳付 港幣＄20補領新手冊。`,
          `5. 缺席者均不設補堂。遲到者不設補時。`,
          `6. 學生若因事或病請假，學生必須於上課前兩小時致電通知本校。`,
          `7. 凡學校假期，全校休息，貴子弟無須上課，可在當月或下一個月內補回。`,
          `8. 本校有權因行政理由而更改任教導師或課堂，而無須另行通知。`,
          `9.除家長書面通知外，本校有權使用學生之相片、錄像及其他個人資料。`,
          `課堂及學費守則`,
          `1. 如付支票，抬頭請寫 (Rainbow Creative Arts)，或可於任何分校借取印章蓋印。`,
          `2. 除書面通知外，本校會假設貴子女每月照常上課。`,
          `3. 如有學生每月更改上課時間或轉換上課地點，需繳付港幣＄100之行政手續費。時間表可於詢問處索取。`,
          `4. 學生如無故缺席或退學，已繳之學費恕不退還。`,
          `5. 如學生需要請假兩星期或以上，學生須於請假前預先通知學校，以保留學籍。`,
          `6. 所有補堂必須於學費期内進行，不在學費期內的補堂均不設退款或順延。`,
          `7.本校接受電話或親臨本校申請補課事宜。`,
          `8. 黃色暴雨警告訊號、紅色暴雨警告訊號，一號颱風或三號颱風訊號，本校照常上課，如因私人理由未能上課將不獲補課或退款。`,
          `9. 黑色暴雨警告訊號、八號颱風訊號或懸掛更高風球時，所有班別一律停課。`,
          `10. 如當月有五個星期，其中一堂為公眾假期、8號風球、黑色暴雨警告，當天課堂則會取消並不設補課。`,
          `11. 所有己繳交之學費，無論任何原因，一律不得退款，轉讓及作其他用途，除「大特殊情況」則獲「酌情處理」。`,
          `*「特殊情況」為學生因健康問題並出示醫生證明文件，證明學生無法進行任何課程,將可獲得「酌情處理」 而最高退款金額上限為六個月之課程學費；若經本校核實無疑，學生須付港幣＄2000元之達約行政費，得以 終止課程。`,
          ``,
          `General Rules`,
          `1. Please attend the class and pick up students on time.`,
          `2. Please do not enter classroom without permission`,
          `3. Please do not eat or drink during the class`,
          `4. Students should place their student handbook at the reception counter before the lessons start. An administrative charge of HK$20 will be required for a re-issued handbook.`,
          `5. No make-up lessons will be provided for the late comers or absentees.`,
          `6. Students who knowingly will be absent from class, please phone the center 2 hours before the lessons start.`,
          `7. No classes will be held on school holidays. All Make-up classes will be arranged and completed within the month.`,
          `8. We reserve the right to change course instructor, time, venue and class content without prior notice`,
          `9. We reserve the rights to use photos, videos and/or sound recordings of the students, unless we are otherwise informed by a parent in writing.`,
          ``,
          `Course and payment rule`,
          `1. For cheque payment, please make it payable to "Rainbow Creative Arts" (stamps is available to borrow in centres.)`,
          `2. We assume that your child will continue with classes from month to month unless you notify us of student's withdrawal one month in advance in writing.`,
          `3. Please consult our staff for changing your lesson schedule every month. An administration charge of HK$100 will be collected for any application of venue or time or class changes.`,
          `4. No refund will be made for any absence from a personal reason or the student deciding to quit.`,
          `5. Please written request before three weeks for leave two weeks or more.`,
          `6. All make up classes have to be arranged within 30 days and course fee period. There is no refund or extension for any make up classes which could not completed within course fee period.`,
          `7. Applying for a make-up class must only be made via the telephone or in person.`,
          `8. Classes will proceed as usual during an amber storm signal, a red storm signal, or a typhoon signal no.3; there is no refund or make-up class if a student does not attend during the aforementioned listed weather conditions as it will be considered a parental decision to attend or not.`,
          `9.Classes will be cancelled when a black storm signal or a typhoon signal no.8 or above is hoisted. Neither refund for the cancelled lesson(s).`,
          `10. There shall be no make up class, if there is any public holiday, black storm signal or typhoon 8 and above happens in a 5-weeks-month.`,
          `11. All paid tuition fees, for any reason, will not be refunded, transferred or used for other purposes, except for "*special circumstances" which will be "discretionary"`,
          `* Special circumstances' are courses for which the student is unable to take any courses due to health problems and presents a doctor's certificate to prove that the student is unable to take any courses. The maximum refund amount is limited to six months. Tuition fees; if verified by the school, students must pay a default administrative fee of HK$2.000 to terminate the course`,
          `* 本校有權修改以上細則而毋須另行通知。如有任何爭議，本校保留最終決定權。`,
          `* Rainbow Creative Arts reserves the right to amend and/or change the conditions of enrollment without prior notice.`,
          ``,
          `In case of any dispute, the school reserves the right to make all decisions final. `
        ],
        student : {
          zh_name: null,
          en_name: null,
          mobile: null,
          address:null,
          birth:null,
          gender:null,
          school_grade:null,
          grade:null,
          student:null,
          center_id:router.currentRoute.params.center_id
        },
        // validation rules
        required,
        email,
      }
    },
    computed: {
      passwordToggleIcon() {
        return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
      },
    },
    created() {
      this.get_student_data()
    },
    methods: {
      clear() {
        this.$refs.signaturePad.clearSignature();
      },
      onBegin() {
        console.log('=== Begin ===');
      },
      onEnd() {
        console.log('=== End ===');
      },
      get_student_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/signature/${router.currentRoute.params.expire_token}/`)
        .then(res => {
          this.student = res.data.student
        })
    },
      submit() {
        if ( this.status === false ) {
            this.$toast({
                component: ToastificationContent,
                position: 'top-center',
                props: {
                  title: 'Error',
                  icon: 'XIcon',
                  variant: 'danger',
                  text: '請同意條款',
                },
              })
              return
        }
        
      //  const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      //  this.student.signature = data
        this.$http.post(process.env.VUE_APP_API_BASE+`/signature/${router.currentRoute.params.expire_token}/sign/`, this.student)
          .then(res => {
            if (res.data.result === true) {
              this.$swal({
                title: 'Success!',
                text: 'Signature success!',
                icon: 'success',
                showConfirmButton : false,
                buttonsStyling: false,
                backdrop: true,
                allowOutsideClick : false,
                allowEscapeKey : false
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-center',
                props: {
                  title: 'Error',
                  icon: 'XIcon',
                  variant: 'danger',
                  text: res.data.message,
                },
              })
            }
          })
      },
    },
  }
  </script>
  
  <style lang="scss">
  @import '@core/scss/vue/pages/page-auth.scss';
  
  .auth-wrapper.auth-v1 .auth-inner {
      max-width: 700px;
  }
  </style>
  